import { useState } from "react";
import { distanceForMileage, getMyLocation, kmToMiles, quoteCalculator } from "../../../utils";

export const useCalculator = () => {
  const token = sessionStorage.getItem("token");
  const [locations, setLocations] = useState([]);
  const [mileageDistance, setMileageDistance] = useState("");

  const getMyLocations = async () => {
    const res = await getMyLocation(token);
    setLocations(res);
  };

  const getDistanceForMileage = async (origin, destination) => {
    const payload = {
      locations: {
        origins: [
          {
            latitude: origin.lat,
            longitude: origin.lng,
          },
        ],
        destinations: [
          {
            latitude: destination.lat,
            longitude: destination.lng,
          },
        ],
      },
    };

    const { data } = await distanceForMileage(token, payload);

    setMileageDistance(
      kmToMiles(data.rows[0].elements[0].distance.value ?? 0).toFixed(2)
    );

    return (data.rows[0].elements[0].distance.value ?? 0).toFixed(2);
  };

  const getCalculatorResult = async (type, data, companyId) => {
    const quotePayload = {
      companyId,
      type,
      payload: data
    };
    const res = await quoteCalculator(token, quotePayload);
    return res.data;
  };

  const getCalculatorResidentialResult = async (payload) => {

    const data = await quoteCalculator(token, payload)

    return data.data
  }


  return {
    //Methods
    getDistanceForMileage,
    getMyLocations,
    getCalculatorResidentialResult,
    getCalculatorResult,

    //Props
    mileageDistance,
    locations,
  };
};
